import { Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { FsessionService } from "src/app/servicios/session/fsession.service";
import { MenuHeader } from "../header/header.component";

@Component({
    templateUrl: "./module-redirect.component.html",
    styleUrls: ["./module-redirect.component.scss"],
    standalone: false
})
export class ModuleRedirectComponent implements OnInit {
  private fse = inject(FsessionService);
  private router = inject(Router);

  headers: MenuHeader[];

  constructor() {
    this.headers = this.fse.getHeaders();
  }

  ngOnInit(): void {
    const firstAvailableRoute = this.headers[0].routerLink;
    if(this.headers[0] && firstAvailableRoute) {
      this.router.navigate([firstAvailableRoute]);
    }
  }
}
